<template>
  <div id="container">
    <div class="product-status">
      <div class="box-content-title">
        <div class="title-font-style">
          <span>{{name==='1'?'客户余额':'供应商余额'}}</span>
        </div>
      </div>
      <el-form class="search-style">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="queryParams.column" @change="changeQueryParams">
                <el-option
                  v-for="(item, index) in customtabs"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="queryParams.expression" v-show="queryParams.column === 'amount'">
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in expressionList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-select v-model="queryParams.value" v-if="queryParams.column === 'tradeType'">
                <el-option label="充值" :value="1"></el-option>
                <el-option label="划拨" :value="2" v-if="name==='1'"></el-option>
                <el-option label="支付" :value="2" v-else></el-option>
                <el-option label="提现" :value="4" v-if="name==='1'"></el-option>
                <!-- <el-option label="供应商活动" :value="6" v-if="name==='2'&&active==='2'"></el-option> -->
                <el-option label="调整金额" :value="5" v-if="name==='1'"></el-option>
                <el-option label="调整金额" :value="3" v-else></el-option>
              </el-select>
              <el-date-picker
                style="width:100%;"
                v-else-if="queryParams.column === 'tradeDate'"
                v-model="time"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <el-input v-model="queryParams.value" v-else></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button type="primary" @click="onSearch">搜索</el-button>
              <el-button plain @click="onReset">重置</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="queryParams.column === 'amount'?4:8" style="text-align: right">
            <el-form-item>
              <el-button plain @click="onExport">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height: $store.state.Sell.heightTitle+'px'}">
        <div class="title-font" v-if="name==='2'">
          <div class="boldi"></div>
          <span @click="tabTop" :class="active==='1'?'active':''" style="margin-left: 26px">账户余额</span>
          <span @click="tabBottom" :class="active==='2'?'active':''" style="margin-left: 40px">抵扣金额</span>
        </div>
        <el-table
          border
          ref="tableRef"
          :data="list"
          :max-height="$store.state.Sell.heightTitle-40"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column :label="name==='1'?'客户名称':'供应商名称'" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="approval" @click="onCusName">{{scope.row.cusName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易时间" v-if="name ==='1'||active==='1'">
            <template slot-scope="scope">{{ scope.row.tradeDate | dateFilterL }}</template>
          </el-table-column>
          <el-table-column label="交易金额">
            <template slot-scope="scope">{{ scope.row.amount | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="变更前可用抵扣金额" v-if="name ==='2'&&active==='2'" width="150">
            <template slot-scope="scope">{{ scope.row.beforAmount | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="变更前可用余额" v-if="name ==='1'||active==='1'">
            <template slot-scope="scope">{{ scope.row.beforAmount | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="变更后可用抵扣余额" v-if="name ==='2'&&active==='2'" width="150">
            <template slot-scope="scope">{{ scope.row.afterAmount | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="变更后可用余额" v-if="name ==='1'||active==='1'">
            <template slot-scope="scope">{{ scope.row.afterAmount | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column prop="tradeType" label="收支类型">
            <template slot-scope="scope">
              <span
                v-if="name==='1'"
              >{{ scope.row.tradeType===1?'充值':scope.row.tradeType===2?'划拨':scope.row.tradeType===5?'调整金额':scope.row.tradeType===4?'提现':'--'}}</span>
              <span
                v-else
              >{{scope.row.tradeType===1?'充值':scope.row.tradeType===2?'支付':scope.row.tradeType===3?'调整金额':scope.row.tradeType===5?'供应商活动':'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="fllowNumber" label="关联工单编号"></el-table-column>
          <el-table-column prop="staffCnName" label="操作人"></el-table-column>
          <el-table-column label="操作时间">
            <template slot-scope="scope">{{ scope.row.createDate | dateFilterL }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :pageSize="pageSize"
          :currentPage="currentPage"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
import { customtabs } from '../../../financeManage/util/data'
import { downLoadFileBlob } from '@/util/tool'
import {
  queryCustomerAccountByFinance,
  querySupplierAccountByFinance,
  financeBalanceCoeDerive
} from '@/api/fiance/fianceManage'
export default {
  components: {
    pagination
  },
  data () {
    return {
      customtabs,
      name: '', // 1 客户 2 供应商
      active: '', // 1 账户余额 2 抵抗金额
      columnArr: [],
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      expressionList,
      queryParams: {},
      time: []
    }
  },
  mounted () {
    this.name = this.$route.query.name
    this.active = this.$route.query.type
    this.getList()
    // this.$refs.paneparents[0].$parent.$parent.$el.childNodes[0].firstChild.style.display =
    //   'none'
  },
  methods: {
    onExport () {
      const { name, active } = this
      const obj = {
        bizId: this.$route.query.id,
        financeType: name === '1' ? 3 : +active,
        financeUrl:
          name === '1'
            ? this.$store.state.cusBalanceUrl
            : active === '1'
              ? this.$store.state.supplierBalanceUrl
              : this.$store.state.supplierDeductionUrl,
        queryCriteriaVo: {
          criteriaVoList: [...this.columnArr],
          queryPageName: ''
        }
      }
      financeBalanceCoeDerive(obj).then((res) => {
        downLoadFileBlob(this, res)
      })
    },
    changeQueryParams (val) {
      this.queryParams = {}
      this.queryParams.column = val
      if (val === 'amount') {
        this.$set(this.queryParams, 'expression', 'eq')
      }
      this.time = []
    },
    onCusName (row) {
      if (this.name === '1') {
        this.$router.push({
          path: '/crm/customer/details',
          query: { id: this.$route.query.id }
        })
      } else {
        this.$router.push({
          path: '/crm/supplier/supplierEdit',
          query: { id: this.$route.query.id }
        })
      }
    },
    tabTop () {
      this.active = '1'
      this.getList()
    },
    tabBottom () {
      this.active = '2'
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList () {
      this.loadingTable = true
      const params = {
        criteriaVoList: [...this.columnArr],
        queryPageName: ''
      }
      if (this.name === '1') {
        queryCustomerAccountByFinance(
          this.$route.query.id,
          this.currentPage,
          this.pageSize,
          params
        ).then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records || []
            this.total = res.data.obj.total
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        querySupplierAccountByFinance(
          this.$route.query.id,
          this.active,
          this.currentPage,
          this.pageSize,
          params
        ).then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records || []
            this.total = res.data.obj.total
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    onReset () {
      // 重置
      this.columnArr = []
      this.time = []
      this.queryParams = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    // 搜索
    onSearch () {
      if (this.time.length === 2) {
        this.queryParams.value = this.time[0]
        this.queryParams.endValue = this.time[1]
      }
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.columnArr = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.title-font {
  margin-bottom: 14px;
  display: flex;
  font-size: 16px;
  line-height: 16px;
  .boldi {
    display: inline-block;
    background-color: #276cff;
    width: 4px;
    height: 20px;
    margin-top: 2px;
  }
  span {
    padding: 2px 0 6px;
  }
  .active {
    border-bottom: 2px solid #276cff;
    color: #276cff;
  }
}
</style>
